/**
 * Active LED Walls — category tab switching (Indoor / Outdoor / Rental /
 * All-in-One / Curved). No page reload; keeps the selected category in the
 * URL (?category=) so a tab can be linked to directly.
 */
(function () {
  function init() {
    var root = document.getElementById('LedCategoryTabs');
    if (!root) return;

    var tabs = Array.prototype.slice.call(root.querySelectorAll('.av-led-tab'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('.av-led-tabpanel'));

    function activate(key, updateUrl) {
      tabs.forEach(function (tab) {
        var isActive = tab.getAttribute('data-category') === key;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      panels.forEach(function (panel) {
        panel.hidden = panel.getAttribute('data-category-panel') !== key;
      });
      if (updateUrl) {
        var params = new URLSearchParams(window.location.search);
        params.set('category', key);
        var qs = params.toString();
        var newUrl = window.location.pathname + (qs ? '?' + qs : '') + window.location.hash;
        window.history.replaceState({ ledCategory: key }, '', newUrl);
      }
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activate(tab.getAttribute('data-category'), true);
      });
    });

    var validKeys = tabs.map(function (t) { return t.getAttribute('data-category'); });
    var params = new URLSearchParams(window.location.search);
    var initial = params.get('category');
    if (initial && validKeys.indexOf(initial) !== -1) {
      activate(initial, false);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
